import { Grid as GridMantine } from '@mantine/core'
import styled from 'styled-components'

export const Grid = styled(GridMantine)`
  gap: ${({ gap }) => gap};
  align-items: ${({ $alignItems }) => $alignItems};

  .mantine-Grid-root {
    display: none;
  }
`
